"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var ListItem_1 = require("./ListItem");

var ListItemText_1 = require("./ListItemText");

var ListContext_1 = require("./ListContext");

var DynamicTag_1 = require("../DynamicTag");

var utils_1 = require("../../utils");

var StyledList = styled_components_1.default(function (_a) {
  var hasSubheader = _a.hasSubheader,
      isDense = _a.isDense,
      rest = __rest(_a, ["hasSubheader", "isDense"]);

  return React.createElement(DynamicTag_1.DynamicTag, __assign({}, rest));
})(function (_a) {
  var theme = _a.theme,
      variant = _a.variant,
      isDense = _a.isDense,
      hasSubheader = _a.hasSubheader;
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'List', variant, null);
  return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      position: relative;\n      padding-top: 8px;\n      padding-bottom: 8px;\n\n      ", "\n\n      ", "\n\n      ", "\n    "], ["\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      position: relative;\n      padding-top: 8px;\n      padding-bottom: 8px;\n\n      ", "\n\n      ", "\n\n      ", "\n    "])), isDense && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          padding-top: 0;\n          padding-bottom: 0;\n        "], ["\n          padding-top: 0;\n          padding-bottom: 0;\n        "]))), hasSubheader && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          padding-top: 8px;\n        "], ["\n          padding-top: 8px;\n        "]))), themeStyles);
});

function List(_a) {
  var children = _a.children,
      _b = _a.component,
      component = _b === void 0 ? 'ul' : _b,
      _c = _a.dense,
      dense = _c === void 0 ? false : _c,
      subheader = _a.subheader;
  var context = React.useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);
  return React.createElement(ListContext_1.ListContext.Provider, {
    value: context
  }, React.createElement(StyledList, {
    component: component,
    hasSubheader: subheader
  }, subheader, children));
}

exports.List = List;
List.Item = ListItem_1.ListItem;
List.ItemText = ListItemText_1.ListItemText;
var templateObject_1, templateObject_2, templateObject_3;